// extracted by mini-css-extract-plugin
export default {"searchBar":"Style_searchBar__e7E3G"};